import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "dcb87fdb-bc13-43bd-82e3-df892977f1d7",
    content: "A floating floor decoupled from</br>the load-bearing structure.",
    options: {},
  },
  { id: "2f7bbc09-cf8d-4a0f-bd06-fa37e53438c4", content: "Resilient suspension of the ceiling.", options: {} },
  { id: "afd0c3a5-d82e-4343-96d4-7420cce3ca72", content: "A layer of added mass.", options: {} },
  { id: "d9f2a17d-355a-49de-86a4-ee471cdfdddd", content: "A floor cover (carpet or similar).", options: {} },
  {
    id: "4feffc7c-240f-4321-896a-7b745f1de34d",
    content: "Low resonance frequency of</br>the floating floor structure.",
    options: {},
  },
  {
    id: "d2e83228-5368-4f1f-9310-d111dd826bf6",
    content: "Hard connection of the suspended</br>ceiling to the surrounding walls.",
    options: {},
  },
  { id: "39268c26-f9b6-4cd0-8418-f639baac6ef8", content: "Bare concrete floor.", options: {} },
  {
    id: "846d97c0-bb2e-4c72-8d32-a975f4045ba6",
    content: "A too heavy top layer</br>of the floating floor.",
    options: {},
  },
  {
    id: "b4cab665-9226-4816-83b7-40dd02ffadf9",
    content: "Hard connection of the floating floor</br>to the surrounding walls.",
    options: {},
  },
  {
    id: "0e2ac0c3-6c49-4bf4-91a6-170b006e9f7a",
    content: "Floor finish laid directly on</br>the load-bearing construction.",
    options: {},
  },
];

export const task: Task = {
  id: "ea7d6697-5746-4b95-863f-3635669b7df0",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "dcb87fdb-bc13-43bd-82e3-df892977f1d7",
    "2f7bbc09-cf8d-4a0f-bd06-fa37e53438c4",
    "afd0c3a5-d82e-4343-96d4-7420cce3ca72",
    "d9f2a17d-355a-49de-86a4-ee471cdfdddd",
    "4feffc7c-240f-4321-896a-7b745f1de34d",
  ],
};
